const copy = {
  en: {
    rewardEyebrow: "TODAY'S BIG REWARD",
    rewardBody: "Hidden in today's podcast",
    expires: "EXPIRES IN",
    challengesTitle: ["TODAY'S", "CHALLENGES"],
    challengesSub: "Complete all 8 — bonus egg +",
    mythTitle: "MYTH OR FACT?",
    myth: "MYTH",
    fact: "FACT",
    mythFact: {
      correctLabel: "CORRECT",
      answerBang: "ANSWER!",
      answer: "ANSWER",
      awesome: "AWESOME!",
      wrongLabel: "WRONG",
      gotIt: "GOT IT",
    },
    tipTitle: "1-MIN PRO TIP",
    mission1: "Listen 1 podcast to the end",
    mission1Sub: "Egg guaranteed",
    mission2: "Play 1 Aim Train round",
    mission2Sub: "Score 250+ for the egg",
    mission3: "Explore 1 Game Feature",
    mission3Sub: "Maps, guns, coins & new drops",
    viewAll: "VIEW ALL",
    storiesTitle: "PRO TIP STORIES",
    storiesSub: "Watch the story, become a pro, take the easter egg",
    podcastTitle: "PODCAST",
    podcastSub: "Gaming podcasts — listen and earn eggs",
    allEpisodes: "ALL EPISODES",
    gameplayTitle: "GAMEPLAY",
    gameplaySub: "Best clips and full gameplay",
    watchClips: "WATCH GAMEPLAY CLIPS",
    featuresTitle: "GAME FEATURES",
    featuresSub: "Maps, guns, coins & everything new this season",
    todaysFeature: "TODAY'S FEATURE",
    newsTitle: "NEWS",
    newsSub: "Esports & gaming news — stay ahead",
    newsHeadline: "PUBG Mobile 3.4 update — new map drops this week",
    allNews: "ALL NEWS",
    footerNav: ["HOME", "PLAY", "VIDEOS", "NEWS", "REWARDS"],
    footerLegal: "© 2026 Gamez Academy · Jazz",
    tips: {
      watch: "Watch the story, become a pro, take the easter egg",
      preview: "3 second preview — tap to watch it all",
    },
    heroSubtitle: "Find the best guide on your favorite games",
    tabs: ["Rookie", "Pro", "Expert"],
    bottom: ["Home", "Play", "Videos", "News", "Rewards"],
    chrome: {
      home: "Home",
      play: "Play",
      videos: "Videos",
      gameplay: "Gameplay",
      features: "Game Features",
      proTips: "Pro Tips",
      news: "News",
      rewards: "Rewards",
      back: "BACK",
      page: {
        "/": "HOME",
        "/play": "PLAY",
        "/guides": "VIDEOS",
        "/bites": "VIDEO",
        "/shorts": "GAME FEATURES",
        "/game": "GAME FEATURES",
        "/tips": "1-MIN PRO TIP",
        "/news": "NEWS",
        "/rewards": "REWARDS",
        "/puzzle": "PUZZLE",
        "/profile": "PROFILE",
      },
    },
    play: {
      skillsEyebrow: "TEST YOUR SKILLS",
      skillsSub: "A new puzzle daily — 1 solve = 1 egg · 250 score = 1 egg",
      aim: "AIM",
      train: "TRAIN",
      aimTitle: "AIM TRAIN",
      aimLine: "30 seconds · tap the targets",
      aimSub: "30 seconds — more targets, more score. Beat your best!",
      playNow: "PLAY NOW",
      puzzleEyebrow: "SOLVE AND WIN",
      puzzle: "PUZZLE",
      game: "GAME",
      puzzleSub: "A new puzzle daily — solve it, win an egg. Beat your brain!",
      puzzleLine: "A new puzzle daily — solve it, win an egg",
      puzzlePiece: "Every piece costs one easter egg",
      solve: "SOLVE",
      currency: "YOUR CURRENCY",
      aimEgg: "Score 250+ for the egg",
    },
    rewards: {
      streakEyebrow: "DAILY STREAK",
      days: "DAYS",
      streak: "STREAK",
      day: "DAY",
      dayStreak: "DAY STREAK",
      egg: "EGG",
      wallet: "WALLET",
      eggs: "EGGS",
      yourCurrency: "YOUR CURRENCY",
      currencyHint:
        "Turn the eggs you've collected into UC, Diamonds and Minecoins.",
      redeemRewards: "REDEEM REWARDS",
      myRewards: "MY REWARDS",
      claimPlus: "CLAIM +1",
      claimed: "CLAIMED",
      comeBack: "Come back tomorrow — your streak grows on Day {n}",
      progress: (have, need, prize) =>
        `${have}/${need} eggs — ${Math.max(0, need - have)} more for ${prize}`,
      redeem: (prize) => "CLAIM YOUR REWARD",
      redeemCta: "REDEEM",
      catalogueEyebrow: "REDEEM REWARDS",
      prize: "PRIZE",
      catalogue: "CATALOGUE",
      prizeCatalogue: "PRIZE CATALOGUE",
      withEggs: "WITH EGGS",
      eggsSpent: "{n} eggs will be spent",
      winsEyebrow: "YOUR WINS",
      redemption: "REDEMPTION",
      history: "HISTORY",
      empty: "No redemptions yet — start collecting eggs!",
      emptyCatalogue: "No prizes available right now — check back soon.",
    },
    news: {
      eyebrow: "LATEST UPDATES",
      gamez: "GAMEZ",
      title: "NEWS",
      subtitle: "Read or listen to the end — that's when the egg drops",
      tabs: ["LATEST NEWS", "REVIEWS", "PROS & CONS", "ARTICLES"],
      all: "ALL",
      showing: "Showing:",
      allGames: "All games",
      empty: "No articles found.",
      loading: "Loading...",
    },
    profile: {
      currentLevel: "CURRENT LEVEL",
      eggs: "EGGS",
      dayStreak: "DAY STREAK",
      edit: "EDIT PROFILE",
      myRewards: "MY REWARDS",
      intro: "WATCH APP INTRO",
      terms: "TERMS OF SERVICE",
      changePhoto: "CHANGE AVATAR",
      firstName: "First Name",
      lastName: "Last Name",
      bio: "Bio",
      gender: "Gender",
      email: "Email",
      dob: "Date of Birth",
      city: "City",
      country: "Country",
      social: "Social Links",
      save: "SAVE CHANGES",
      male: "Male",
      female: "Female",
    },
    podcast: {
      eyebrow: "WATCH AND WIN",
      title: "PODCAST",
      titleAccent: "VIDEOS",
      subtitle: "watch the podcast the egg is guranted",
      tabs: [
        "ALL GAMES",
        "VALORANT",
        "PUBG",
        "CALL OF DUTY",
        "FORTNITE",
        "MINECRAFT",
        "FREE FIRE",
      ],
      nowPlaying: "Now playing-Egg is hidden in the podcast",
      podcastMeta: "Podcast • PUBG Mobile",
      eggMessage: "listen the podcast, the egg is guranteed",
      rating: "rating",
      ratings: "ratings",
      nextVideo: "NEXT VIDEO • KEEP WATCHING",
      viewMore: "More Guides",
      viewMoreLoading: "LOADING...",
      noMore: "No more videos for this skill level",
      empty: "No podcasts found.",
      titles: {},
    },
    video: {
      watchAll: "Watch it all — the egg comes at the end",
      watchEnd: "Watch to the end — egg guaranteed!",
      allVideos: "ALL VIDEOS",
      videos: "VIDEOS",
      share: "Share",
    },
    dialogs: {
      redeem: "REDEEM",
      confirmRedeem: "CONFIRM REDEEM",
      claimYourReward: "CLAIM YOUR REWARD",
      claimCongrats: "Congratulations!",
      claimAbout: "You're about to claim your reward",
      fullName: "Full Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      rewardId: "ID",
      namePlaceholder: "Enter your full name",
      emailPlaceholder: "name@email.com",
      phonePlaceholder: "92 3XX XXXXXXX",
      gamingId: "Gaming ID",
      gamingIdPlaceholder: "Enter your gaming ID",
      gamingIdHint: "Gaming ID must be 5-15 digits",
      submitClaim: "SUBMIT CLAIM",
      claimInvalid: "Enter your name, email, phone and ID to continue.",
      otpTitle: "Enter your code",
      otpSent: "We texted a 4-digit code to {phone}",
      otpEnter: "Enter the 4-digit OTP sent to your Jazz number",
      deliveredWithin: "Delivered to your account within 24 hours",
      eggsWillBeSpent: "eggs will be spent",
      otpMissing: "Didn't get it?",
      otpResend: "Resend",
      otpTimer: "Code expires in {time}",
      otpExpired: "This code has expired.",
      otpSendAgain: "Send again",
      otpChecking: "Checking your code",
      otpCheckingBody: "One moment — we're confirming it.",
      otpVerified: "Verified",
      otpSettingUp: "Setting up your reward...",
      otpCancel: "CANCEL",
      otpSubmit: "SUBMIT",
      otpSendFailed: "We couldn't send the code. Try again.",
      otpClaimFailed: "That code could not be verified. Try again.",
      otpInvalid: "INVALID OTP",
      claimOops: "OOPS!",
      claimIdMismatch:
        "This gaming ID is not linked to your phone number. Use the ID linked to this Jazz number.",
      notNow: "NOT NOW",
      eggsSpent: "{n} eggs will be spent",
      jazzWithin: "{phone} · Jazz within 24 hours",
      arrivingOn: "{game} · arriving on {phone} within 24 hours",
      jazzInbox: "Jazz number receiving {prize} — 12 hours max to inbox",
      redeemConfirmed: "REDEEM CONFIRMED",
      requestReceived: "REQUEST RECEIVED",
      thankYou: "THANK YOU!",
      requestReceivedBody:
        "We've received your redemption request — our team will contact you within 24 hours.",
      businessHours:
        "Business hours: Monday to Friday, 9:00 AM – 10:00 PM. Requests sent after 10:00 PM on Friday are processed the following Monday.",
      happyGaming: "Happy Gaming!",
      backToRewards: "BACK TO REWARDS",
      onTheWay: "{prize} ON THE WAY",
      eggsDeducted: "{n} eggs deducted",
      ok: "OK",
      insufficientEggs: "Not enough eggs yet — keep collecting!",
      cantRedeemYet: "CAN'T REDEEM YET",
      notEnough: "NOT ENOUGH",
      notEnoughEggs: "EGGS",
      notEnoughBody:
        "You don't have enough eggs for this reward yet. Play challenges and collect more eggs!",
      minimumNeeded: "MINIMUM NEEDED",
      eggsUnit: "EGGS",
      earnMoreEggs: "EARN MORE EGGS",
      dailyStreak: "DAILY STREAK",
      day: "DAY",
      streakAliveTitle: "Streak alive!",
      streakAlive: "Come back daily — 2× eggs bonus on Day 7",
      claimPlus: "CLAIM +1",
      alreadyClaimed: "TODAY'S EGG ALREADY CLAIMED",
      alreadyClaimedBody:
        "Come back tomorrow — your streak grows on Day {n}, 2× eggs bonus on Day 7",
      playChallenges: "SEE CHALLENGES",
      later: "LATER",
      dayStreak: "DAY STREAK",
      eggCollected: "EGG",
      eggCollectedAccent: "COLLECTED!",
      collectedChip: "COLLECTED!",
      easterEggN: "Easter Egg #{n} collected",
      eggsEarned: "+{n} Easter Eggs",
      moreNeeded: "{n} more",
      plusOne: "+1",
      awesome: "AWESOME!",
      rateChip: "Rate this content",
      ratePrompt: "How would you rate this content?",
      commentOptional: "Add a comment (optional)",
      eggOnReview: "+1 easter egg on review",
      submit: "Submit",
      clickPiece: "Click on any piece to unlock it.",
      piecesUnlocked: "{u}/{t} pieces unlocked",
      moreEggs: "{n} more eggs needed",
      unlockHint: "Unlock all pieces then redeem your gift",
      puzzleCompleteChip: "Puzzle complete!",
      readyRedeem: "Ready to redeem",
      claimYourEgg: "CLAIM YOUR EGG",
      battlefield: "Battlefield Awaits You",
      freeTrial: "FREE TRIAL",
      freeTrialBody:
        "Dear Customer, you are currently using FREE TRIAL. Please subscribe by exchanging your amount to redeem your reward.",
      puzzleComplete: "PUZZLE COMPLETE",
      rewardsCollected: "REWARDS COLLECTED!",
      plusEggs: "+{n} EASTER EGGS",
      newBalance: "New balance: {n} eggs",
      newPuzzleTomorrow: "NEW PUZZLE TOMORROW",
      newPuzzleBody:
        "A new puzzle unlocks at midnight. Come back tomorrow to collect today's gift.",
      playTodaysPuzzles: "PLAY TODAY'S PUZZLES",
      easterFound: "EASTER EGG FOUND!",
      easterFoundBody:
        "You've discovered an easter egg. Copy this code and use it to unlock puzzle pieces.",
      copyCode: "COPY CODE",
      copied: "COPIED",
      enterCode: "ENTER EASTER EGG CODE",
      enterCodeBody: "Enter the 6-character code from videos to unlock this piece.",
      jazzNumber: "JAZZ NUMBER",
      jazzNumberBody: "Enter your valid Jazz number to continue.",
      chooseReward: "CHOOSE YOUR REWARD",
      chooseRewardLead: "CHOOSE YOUR",
      chooseRewardAccent: "REWARD",
      chooseRewardBody: "Select a game reward to redeem your completed puzzle.",
      redeemYourReward: "REDEEM YOUR REWARD",
      pickCurrency: "Pick one of the two rewards",
    },
  },
  ur: {
    rewardEyebrow: "AAJ KA BARA REWARD",
    rewardBody: "Aaj ke podcast mein chhupa hai",
    expires: "KHATAM HONE MEIN",
    challengesTitle: ["AAJ KE", "CHALLENGES"],
    challengesSub: "8 complete karo — bonus egg +",
    mythTitle: "MYTH YA FACT?",
    myth: "MYTH",
    fact: "FACT",
    mythFact: {
      correctLabel: "SAHI",
      answerBang: "JAWAB!",
      answer: "JAWAB",
      awesome: "ZABARDAST!",
      wrongLabel: "GALAT",
      gotIt: "SAMJH GAYA",
    },
    tipTitle: "1-MIN PRO TIP",
    mission1: "1 podcast end tak suno",
    mission1Sub: "Egg pakka",
    mission2: "1 Aim Train round khelo",
    mission2Sub: "Egg ke liye 250+ score karo",
    mission3: "1 Game Feature dekho",
    mission3Sub: "Maps, guns, coins & new drops",
    viewAll: "SAB DEKHO",
    storiesTitle: "PRO TIP STORIES",
    storiesSub: "Story dekho, pro bano, aur easter egg hasil karo",
    podcastTitle: "PODCAST",
    podcastSub: "Gaming podcasts — suno aur eggs kamao",
    allEpisodes: "SAARE EPISODES",
    gameplayTitle: "GAMEPLAY",
    gameplaySub: "Best clips aur full gameplay",
    watchClips: "GAMEPLAY CLIPS DEKHO",
    featuresTitle: "GAME FEATURES",
    featuresSub: "Maps, guns, coins & is season ki har nayi cheez",
    todaysFeature: "AAJ KA FEATURE",
    newsTitle: "KHABREIN",
    newsSub: "Esports & gaming news — aage raho",
    newsHeadline: "PUBG Mobile 3.4 update — naya map is hafte",
    allNews: "SAARI KHABREIN",
    footerNav: ["HOME", "KHELO", "VIDEOS", "KHABREIN", "INAAM"],
    footerLegal: "© 2026 Gamez Academy · Jazz",
    tips: {
      watch: "Story dekho, pro bano, easter egg lo",
      preview: "3 second preview — poori story ke liye tap karo",
    },
    heroSubtitle: "Apne favorite games ke best guides yahan milenge",
    tabs: ["Rookie", "Pro", "Expert"],
    bottom: ["Home", "Khelo", "Videos", "News", "Rewards"],
    chrome: {
      home: "Home",
      play: "Khelo",
      videos: "Videos",
      gameplay: "Gameplay",
      features: "Game Features",
      proTips: "Pro Tips",
      news: "News",
      rewards: "Inaam",
      back: "WAPAS",
      page: {
        "/": "HOME",
        "/play": "KHELO",
        "/guides": "VIDEOS",
        "/bites": "VIDEO",
        "/shorts": "GAME FEATURES",
        "/game": "GAME FEATURES",
        "/tips": "1-MIN PRO TIP",
        "/news": "NEWS",
        "/rewards": "INAAM",
        "/puzzle": "PUZZLE",
        "/profile": "PROFILE",
      },
    },
    play: {
      skillsEyebrow: "APNI SKILL AZMAO",
      skillsSub: "Roz naya puzzle — 1 solve = 1 egg · 250 score = 1 egg",
      aim: "AIM",
      train: "TRAIN",
      aimTitle: "AIM TRAIN",
      aimLine: "30 seconds · targets pe tap karo",
      aimSub: "30 second - jitne targets utna score. Beat karo apna best!",
      puzzleEyebrow: "SOLVE KARO AUR JEETO",
      puzzle: "PUZZLE",
      game: "GAME",
      puzzleSub: "Roz naya puzzle — solve karo, egg jeeto. Dimagh azmao!",
      puzzleLine: "Roz naya puzzle — solve karo, egg jeeto",
      puzzlePiece: "Har piece ek easter egg ka hai",
      playNow: "ABHI KHELO",
      solve: "SOLVE",
      currency: "AAPKI CURRENCY",
      aimEgg: "Egg ke liye 250+ score karo",
    },
    rewards: {
      streakEyebrow: "DAILY STREAK",
      days: "DIN",
      streak: "STREAK",
      day: "DIN",
      dayStreak: "DIN STREAK",
      egg: "EGG",
      wallet: "WALLET",
      eggs: "EGGS",
      yourCurrency: "AAPKI CURRENCY",
      currencyHint:
        "Collect kiye hue eggs ko UC, Diamonds aur Minecoins mein badlo.",
      redeemRewards: "REWARDS REDEEM KARO",
      myRewards: "MERE REWARDS",
      claimPlus: "CLAIM +1",
      claimed: "CLAIMED",
      comeBack: "Kal wapas aao — Day {n} par streak barhegi",
      progress: (have, need, prize) =>
        `${have}/${need} eggs — ${prize} ke liye ${Math.max(0, need - have)} aur`,
      redeem: (prize) => "APNA REWARD CLAIM KARO",
      redeemCta: "REDEEM",
      catalogueEyebrow: "REWARDS REDEEM KARO",
      prize: "PRIZE",
      catalogue: "CATALOGUE",
      prizeCatalogue: "PRIZE CATALOGUE",
      withEggs: "WITH EGGS",
      eggsSpent: "{n} eggs kharch honge",
      winsEyebrow: "AAP KI JEET",
      redemption: "REDEMPTION",
      history: "HISTORY",
      empty: "Abhi koi redemption nahi — eggs collect karna shuru karo!",
      emptyCatalogue: "Abhi koi prize nahi — jaldi wapas check karo.",
    },
    news: {
      eyebrow: "TAZA UPDATES",
      gamez: "GAMEZ",
      title: "NEWS",
      subtitle: "End tak parho ya suno — tabhi egg milta hai",
      tabs: ["TAZA NEWS", "REVIEWS", "PROS & CONS", "ARTICLES"],
      all: "SAB",
      showing: "Dikha rahe hain:",
      allGames: "Saare games",
      empty: "Koi article nahi mila.",
      loading: "Load ho raha hai...",
    },
    profile: {
      currentLevel: "CURRENT LEVEL",
      eggs: "EGGS",
      dayStreak: "DIN STREAK",
      edit: "PROFILE EDIT KARO",
      myRewards: "MERE REWARDS",
      intro: "APP INTRO DEKHO",
      terms: "TERMS OF SERVICE",
      changePhoto: "PHOTO BADLO",
      firstName: "Pehla naam",
      lastName: "Aakhri naam",
      bio: "Bio",
      gender: "Gender",
      email: "Email",
      dob: "Date of Birth",
      city: "City",
      country: "Country",
      social: "Social Links",
      save: "CHANGES SAVE KARO",
      male: "Male",
      female: "Female",
    },
    podcast: {
      eyebrow: "DEKHO AUR JEETO",
      title: "PODCAST",
      titleAccent: "VIDEOS",
      subtitle: "Video dekho, egg lejao",
      tabs: [
        "SAARE GAMES",
        "VALORANT",
        "PUBG",
        "CALL OF DUTY",
        "FORTNITE",
        "MINECRAFT",
        "FREE FIRE",
      ],
      nowPlaying: "Abhi chal raha hai - Egg podcast mein chhupa hai",
      podcastMeta: "Podcast • PUBG Mobile",
      eggMessage: "Video dekho, egg lejao",
      rating: "rating",
      ratings: "ratings",
      nextVideo: "NEXT VIDEO • AGE DEKHO",
      viewMore: "More Guides",
      viewMoreLoading: "LOAD HO RAHA HAI...",
      noMore: "Is skill level par aur videos nahi",
      empty: "Koi podcast nahi mila.",
      titles: {
        "movement tips _ tricks - call of duty - podcast":
          "Call Of Duty ki movement tips aur tricks - Podcast",
        "legends in action": "Legends maidan mein",
        "use pets strategically": "Pets ko hikmat se istemal karo",
        "mobs and their factors - minecraft - gameplay":
          "Mobs aur unki khasusiyat - Minecraft - Gameplay",
        "capatalizing airdrops": "Airdrops ka behtareen istemal",
      },
    },
    video: {
      watchAll: "Poori video dekho — egg end par aata hai",
      watchEnd: "End tak dekho — egg pakka!",
      allVideos: "SAARI VIDEOS",
      videos: "VIDEOS",
      share: "Share",
    },
    dialogs: {
      redeem: "REDEEM",
      confirmRedeem: "CONFIRM REDEEM",
      claimYourReward: "REWARD CLAIM KARO",
      claimCongrats: "Mubarak ho!",
      claimAbout: "Aap apna reward claim karne wale hain",
      fullName: "Full Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      rewardId: "ID",
      namePlaceholder: "Apna full name likho",
      emailPlaceholder: "name@email.com",
      phonePlaceholder: "92 3XX XXXXXXX",
      gamingId: "Gaming ID",
      gamingIdPlaceholder: "Apna gaming ID likho",
      gamingIdHint: "Gaming ID 5-15 digits honi chahiye",
      submitClaim: "SUBMIT CLAIM",
      claimInvalid: "Aage barhne ke liye name, email, phone aur ID likho.",
      otpTitle: "Apna code likho",
      otpSent: "4-digit code {phone} par bheja gaya",
      otpEnter: "Jazz number par bheja hua 4-digit OTP likho",
      deliveredWithin: "24 ghante ke andar aapke account mein deliver hoga",
      eggsWillBeSpent: "eggs kharch honge",
      otpMissing: "Nahi mila?",
      otpResend: "Dobara bhejo",
      otpTimer: "Code {time} mein khatam hoga",
      otpExpired: "Yeh code khatam ho gaya.",
      otpSendAgain: "Dobara bhejo",
      otpChecking: "Code check ho raha hai",
      otpCheckingBody: "Ek lamha — confirm kar rahe hain.",
      otpVerified: "Verified",
      otpSettingUp: "Reward set ho raha hai...",
      otpCancel: "CANCEL",
      otpSubmit: "SUBMIT",
      otpSendFailed: "Code nahi bhej sake. Dobara koshish karo.",
      otpClaimFailed: "Yeh code verify nahi hua. Dobara koshish karo.",
      otpInvalid: "GHALAT OTP",
      claimOops: "OOPS!",
      claimIdMismatch:
        "Yeh gaming ID aapke phone number se link nahi hai. Is Jazz number se linked ID use karo.",
      notNow: "ABHI NAHI",
      eggsSpent: "{n} eggs kharch honge",
      jazzWithin: "{phone} · Jazz 24 ghante ke andar",
      arrivingOn: "{game} · {phone} par 24 ghante ke andar",
      jazzInbox: "Jazz number par {prize} — inbox mein 12 ghante",
      redeemConfirmed: "REDEEM CONFIRM HO GAYA",
      requestReceived: "REQUEST MIL GAYI",
      thankYou: "SHUKRIYA!",
      requestReceivedBody:
        "Aapki redemption request mil gayi hai — hamari team 24 ghante ke andar rabta karegi.",
      businessHours:
        "Business hours: Monday se Friday, 9:00 AM – 10:00 PM. Friday 10:00 PM ke baad bheji gayi requests agle Monday process hoti hain.",
      happyGaming: "Happy Gaming!",
      backToRewards: "REWARDS PAR JAYEIN",
      onTheWay: "{prize} RAH MEIN HAI",
      eggsDeducted: "{n} eggs kat gaye",
      ok: "THEEK HAI",
      insufficientEggs: "Abhi eggs kam hain — collect karte raho!",
      cantRedeemYet: "ABHI REDEEM NAHI HO SAKTA",
      notEnough: "EGGS KAM",
      notEnoughEggs: "HAIN",
      notEnoughBody:
        "Is reward ke liye eggs kam hain. Challenges khelo aur mazeed eggs jama karo!",
      minimumNeeded: "KAM AZ KAM",
      eggsUnit: "EGGS",
      earnMoreEggs: "MAZEED EGGS KAMAO",
      dailyStreak: "DAILY STREAK",
      day: "DAY",
      streakAliveTitle: "Streak zinda hai!",
      streakAlive: "Roz aao — Day 7 par 2× eggs bonus",
      claimPlus: "CLAIM +1",
      alreadyClaimed: "AAJ KA EGG PEHLE LE LIYA",
      alreadyClaimedBody:
        "Kal wapas aao — Day {n} par streak barhegi, Day 7 par 2× eggs bonus",
      playChallenges: "CHALLENGES DEKHO",
      later: "BAAD MEIN",
      dayStreak: "DIN STREAK",
      eggCollected: "EGG",
      eggCollectedAccent: "MIL GAYA!",
      collectedChip: "COLLECTED!",
      easterEggN: "Easter Egg #{n} mil gaya",
      eggsEarned: "+{n} Easter Eggs",
      moreNeeded: "{n} aur",
      plusOne: "+1",
      awesome: "ZABARDAST!",
      rateChip: "Is content ko rate karo",
      ratePrompt: "Is content ko kitna rate karoge?",
      commentOptional: "Comment likho (optional)",
      eggOnReview: "review par +1 easter egg",
      submit: "Submit",
      clickPiece: "Unlock karne ke liye kisi piece par click karo.",
      piecesUnlocked: "{u}/{t} pieces unlock",
      moreEggs: "{n} aur eggs chahiye",
      unlockHint: "Gift redeem karne se pehle saare pieces unlock karo",
      puzzleCompleteChip: "Puzzle complete!",
      readyRedeem: "Redeem ke liye ready",
      claimYourEgg: "APNA EGG LO",
      battlefield: "Battlefield Awaits You",
      freeTrial: "FREE TRIAL",
      freeTrialBody:
        "Dear Customer, aap abhi FREE TRIAL use kar rahe hain. Reward redeem karne ke liye amount exchange karke subscribe karein.",
      puzzleComplete: "PUZZLE COMPLETE",
      rewardsCollected: "REWARDS MIL GAYE!",
      plusEggs: "+{n} EASTER EGGS",
      newBalance: "Naya balance: {n} eggs",
      newPuzzleTomorrow: "KAL NAYA PUZZLE",
      newPuzzleBody:
        "Naya puzzle midnight par unlock hoga. Aaj ka gift lene kal aana.",
      playTodaysPuzzles: "AAJ KE PUZZLES KHELO",
      easterFound: "EASTER EGG MIL GAYA!",
      easterFoundBody:
        "Aapko easter egg mil gaya. Code copy karke puzzle pieces unlock karo.",
      copyCode: "CODE COPY KARO",
      copied: "COPY HO GAYA",
      enterCode: "EASTER EGG CODE LIKHO",
      enterCodeBody: "Is piece ko unlock karne ke liye videos se 6-character code likho.",
      jazzNumber: "JAZZ NUMBER",
      jazzNumberBody: "Continue karne ke liye apna valid Jazz number likho.",
      chooseReward: "APNA REWARD CHUNO",
      chooseRewardLead: "APNA",
      chooseRewardAccent: "REWARD CHUNO",
      chooseRewardBody: "Completed puzzle ke liye game reward select karo.",
      redeemYourReward: "REWARD REDEEM KARO",
      pickCurrency: "Do rewards mein se ek chuno",
    },
  },
};

export function getPodcastTitle(title, lang) {
  if (lang !== "ur" || !title) return title;
  const normalizedTitle = title.trim().replace(/\s+/g, " ").toLowerCase();
  return copy.ur.podcast.titles[normalizedTitle] || title;
}

export default copy;
